import { createSelector } from "reselect";

const selectUser = (state: any) => state.base_login;

/***************  USER LOGIN START  ******************/
export const selectCurrentUser = createSelector(
  [selectUser],
  (base_login) => base_login.loginResponse,
);

// UPDATE LOGIN DATE TIME
export const selectLoginDateTime = createSelector(
  [selectUser],
  (base_login) => base_login.loginDateTime,
);

/*****************  USER AUTH VERIFY START  *******************/
export const selectAuthVerifyResponse = createSelector(
  [selectUser],
  (base_login) => base_login.userAuthVerifyResponse,
);

export const selectAuthCheck = createSelector(
  [selectUser],
  (base_login) => base_login.authCheckDone,
);
/***************** 	USER AUTH VERIFY END  *****************/

export const selectCurrentDecodedUser = createSelector(
  [selectUser],
  (base_login) => base_login.loginDeocodedResponse,
);

/*****************  FORGOT PASSWORD START  *******************/
export const selectForgotPasswordResp = createSelector(
  [selectUser],
  (base_login) => base_login.forgotPasswordResponse,
);

export const selectForgotPasswordRespDetails = createSelector(
  [selectUser],
  (base_login) => base_login.forgotPasswordDeocodedResponse,
);
/***************** 	FORGOT PASSWORD END  *****************/

/*****************  UPDATE LOGIN USER PASSWORD START  *******************/
export const selectUpdateUserPasswordStatus = createSelector(
  [selectUser],
  (base_login) => base_login.updateUserPasswordStatus,
);

export const selectUpdateUserPasswordResp = createSelector(
  [selectUser],
  (base_login) => base_login.updateUserPasswordResponse,
);
/***************** 	UPDATE LOGIN USER PASSWORD END  *****************/

export const selectIsAdminUser = createSelector([selectUser], (base_login) => {
  const { loginDeocodedResponse } = base_login;
  let isUserAdmin = "0";
  if (
    loginDeocodedResponse !== null &&
    loginDeocodedResponse !== undefined &&
    loginDeocodedResponse.length > 0
  ) {
    const { isAdmin } = loginDeocodedResponse[0];
    isUserAdmin = isAdmin;
  }
  return isUserAdmin;
});

/** ***************** GET USER COMPANY DETAILS START *********************** */
export const selectUserCompanyDetailsResponse = createSelector(
  [selectUser],
  (base_login) => base_login.getUserLoginDetailsResponse,
);

export const selectUserCompanyDetailsData = createSelector(
  [selectUser],
  (base_login) => base_login.loginDeocodedResponse,
);
/** ***************** GET USER COMPANY DETAILS END *********************** */

export const getLoginObjDetails = createSelector([selectUser], (base_login) => {
  const { loginDeocodedResponse } = base_login;

  const defaultLoginObj: any = {
    UserID: "",
    AgentID: "",
    BranchID: "",
    CompanyID: "",
    UserName: "",
    UserLevel: "",
    UserTypeID: "",
    UserTypeName: "",
    UserPassword: "",
    UserPhoneNumber: "",
    CompanyName: "",
    CompanyPhoneNo: "",
    InstanceName: "",
    UserPhoto: "",
    GeneralCompanyID: "",
    GeneralUserID: "",
  };

  if (
    !Array.isArray(loginDeocodedResponse) ||
    loginDeocodedResponse.length === 0
  ) {
    return defaultLoginObj;
  }

  const mergedUser = loginDeocodedResponse.reduce(
    (acc: any, curr: any) => ({ ...acc, ...curr }),
    {},
  );
  console.log("mergedUser Selector Check:", mergedUser);

  return {
    UserID: mergedUser?.UserID ?? "",
    AgentID: mergedUser?.AgentID ?? "",
    BranchID: mergedUser?.BranchID ?? "",
    CompanyID: mergedUser?.CompanyID ?? "",
    UserName: mergedUser?.UserName ?? "",
    UserLevel: mergedUser?.UserLevel ?? "",
    UserTypeID: mergedUser?.UserTypeID ?? "",
    UserTypeName: mergedUser?.UserTypeName ?? "",
    UserPassword: mergedUser?.UserPassword ?? "",
    UserPhoneNumber: mergedUser?.UserPhoneNumber ?? "",
    CompanyName: mergedUser?.CompanyName ?? "",
    CompanyPhoneNo: mergedUser?.CompanyPhoneNo ?? "",
    InstanceName: mergedUser?.InstanceName ?? "",
    UserPhoto: mergedUser?.userPhoto ?? "",
    GeneralCompanyID: mergedUser?.GeneralCompanyID ?? "",
    GeneralUserID: mergedUser?.GeneralUserID ?? "",
    // RBAC grants — WITHOUT this the sidebar, route guard AND CRUD gating all
    // received undefined and fell back to "show everything". This whitelist
    // selector used to silently drop it. It carries the Assign-User-Rights
    // grants (menuName → submenu[] → Isshow/Isadd/Isedit/Isdelete).
    userAccessData: mergedUser?.userAccessData ?? [],
  };
});

/** 2FA pending state — set after password when the staff has activated
 *  Google Authenticator. Holds the short-lived PendingToken for step-2. */
export const getTotpPending = createSelector([selectUser], (base_login) => {
  const d = base_login.totpPendingDecoded;
  if (!Array.isArray(d) || d.length === 0) return null;
  const m = d.reduce((acc: any, curr: any) => ({ ...acc, ...curr }), {});
  if (!m || (!m.TotpRequired && !m.PendingToken)) return null;
  return {
    PendingToken: m.PendingToken ?? "",
    UserID: m.UserID ?? "",
    InstanceName: m.InstanceName ?? "",
    UserName: m.UserName ?? "",
    // which second factors this staff has active (backend accepts either)
    TotpEnabled: Number(m.TotpEnabled ?? 0),
    PinSet: Number(m.PinSet ?? 0),
  };
});
